export default (sitemap: SitemapBuilder) =>
{
    sitemap.push([
        {
            name: '[[[Strona główna]]]',
            short: '[[[Start]]]',
            route: 'dashboard',
            icon: 'house',
            children: [
                {
                    name: '[[[Profil użytkownika]]]',
                    route: 'core-account-profile',
                    icon: 'circle-user'
                },
                {
                    name: '[[[Zmiana hasła]]]',
                    route: 'core-account-password',
                    icon: 'lock-keyhole',
                    visible: false
                },
                {
                    name: '[[[Bezpieczeństwo]]]',
                    route: 'core-account-security',
                    icon: 'monitor-smartphone'
                },
                {
                    name: '[[[Połączenie z MCP]]]',
                    route: 'core-account-mcp',
                    icon: 'plug'
                },
                {
                    name: '[[[Weryfikacja dwuetapowa]]]',
                    route: 'core-account-two-factor',
                    icon: 'shield-check'
                },
                {
                    name: '[[[Dashboardy]]]',
                    route: 'core-dashboards',
                    icon: 'layout-dashboard',
                    namespace: 'Ideo.Core.Common.Application.Permissions.Core',
                    auth: { all: ['DashboardsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie dashboardu]]]',
                            route: 'core-dashboards-add',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja dashboardu]]]',
                            route: 'core-dashboards-edit',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja aranżacji dashboardu]]]',
                            route: 'core-dashboards-layout',
                            auth: { all: ['DashboardsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[System]]]',
            short: '[[[System]]]',
            icon: 'monitor',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            children: [
                {
                    name: '[[[Administracja]]]',
                    icon: 'folder-cog',
                    children: [
                        {
                            name: '[[[Użytkownicy]]]',
                            route: 'core-users',
                            icon: 'user',
                            auth: { all: ['UsersPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie użytkownika]]]',
                                    route: 'core-users-add',
                                    auth: { all: ['UsersPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja użytkownika]]]',
                                    route: 'core-users-edit',
                                    auth: { all: ['UsersPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Role i uprawnienia]]]',
                            route: 'core-roles',
                            icon: 'user-shield',
                            auth: { all: ['RolesPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie roli]]]',
                                    route: 'core-roles-add',
                                    auth: { all: ['RolesPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja roli]]]',
                                    route: 'core-roles-edit',
                                    auth: { all: ['RolesPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Monitoring]]]',
                    icon: 'chart-column',
                    children: [
                        {
                            name: '[[[Historia logowania]]]',
                            route: 'core-authlog',
                            icon: 'file-input',
                            auth: { all: ['AuthAdminPermissions@Authlog'], any: [] }
                        },
                        {
                            name: '[[[Rejestr zmian]]]',
                            route: 'core-changelog',
                            icon: 'file-signature',
                            auth: { all: ['AdministrationSettingsPermissions@Changelog'], any: [] },
                            children: [
                                {
                                    name: '[[[Szczegóły zdarzenia]]]',
                                    route: 'core-changelog-diff',
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Harmonogram zadań]]]',
                            route: 'core-scheduler',
                            icon: 'clock',
                            auth: { all: ['SchedulerPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Historia zadania]]]',
                                    route: 'core-scheduler-history',
                                    visible: false
                                },
                                {
                                    name: '[[[Szczegóły zadania]]]',
                                    route: 'core-scheduler-details',
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Monitor kolejek]]]',
                            route: 'core-queues',
                            icon: 'clock',
                            auth: { all: ['MessagePermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Szczegóły zadania]]]',
                                    route: 'core-queues-details',
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Monitoring aplikacji]]]',
                            route: 'core-monitoring',
                            icon: 'shield-alt',
                            auth: { all: ['AdministrationSettingsPermissions@Monitoring'], any: [] }
                        },
                        {
                            name: '[[[Logowanie zdarzeń]]]',
                            route: 'core-logs',
                            icon: 'shield-alt',
                            auth: { all: ['AdministrationSettingsPermissions@Logs'], any: [] },
                            children: [
                                {
                                    name: '[[[Edycja logów]]]',
                                    route: 'core-logs-edit',
                                    auth: { all: ['AdministrationSettingsPermissions@Logs'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Ustawienia]]]',
                    icon: 'settings',
                    children: [
                        {
                            name: '[[[Bezpieczeństwo]]]',
                            route: 'core-security',
                            icon: 'shield-alt',
                            auth: { all: ['AuthAdminPermissions@Security'], any: [] }
                        },
                        {
                            name: '[[[Zaufane adresy IP]]]',
                            route: 'core-trusted-ips',
                            icon: 'shield-alt',
                            auth: { all: ['AdministrationSettingsPermissions@TrustedIPs'], any: [] }
                        },
                        {
                            name: '[[[ReCaptcha]]]',
                            route: 'core-recaptcha',
                            icon: 'shield-alt',
                            auth: { all: ['AdministrationSettingsPermissions@Recaptcha'], any: [] }
                        },
                        {
                            name: '[[[Poczta wychodząca]]]',
                            route: 'core-mailing',
                            icon: 'mail',
                            auth: { all: ['AdministrationSettingsPermissions@Mailing'], any: [] }
                        },
                        {
                            name: '[[[Sztuczna inteligencja]]]',
                            route: 'ai-settings',
                            icon: 'microchip',
                            auth: { all: ['AiSettingsPermissions@Ai'], any: [] }
                        },
                        {
                            name: '[[[Oceny asystenta AI]]]',
                            route: 'ai-feedback',
                            icon: 'thumbs-up',
                            auth: { all: ['AiSettingsPermissions@Ai'], any: [] }
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Repozytorium plików]]]',
            short: '[[[Pliki]]]',
            route: 'filemanager',
            preventCloseMenu: true,
            icon: 'folder-closed',
            namespace: 'Ideo.Core.Common.Application.Permissions.Storage',
            auth: { all: ['StoragePermissions@Access'], any: [] }
        },
        {
            name: '[[[Kosz]]]',
            short: '[[[Kosz]]]',
            route: 'trash',
            preventCloseMenu: true,
            icon: 'trash',
            namespace: 'Ideo.Core.Common.Application.Permissions.Core',
            auth: { all: ['TrashPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Grupa]]]',
                    route: 'trash-group',
                    visible: false
                }
            ]
        }
    ]);
};
